import { SelectCreatableInput } from '@core/components/Select';
import { clienteApi } from 'app/services/api/clienteApi';
import React from 'react';

const carregarCliente = async (query = '', page = 0) => {
  const response = await clienteApi.get({
    page,
    size: 100,
    sort: 'pessoa.nome,asc',
    q: query?.length ? query : '',
  });
  if (response?.data && response.data.content) {
    return response.data.content;
  }
  return [];
};

const SelectClienteCreatable = ({
  value,
  touched,
  error,
  onChange,
  onBlur,
  label = 'Cliente',
  id,
  autoFocus,
  mutiple,
  required,
  disabled,
  tamanhoMinimo = 3,
  maxLength,
}) => {
  const handleChange = (value) => {
    const event = {
      target: {
        id,
        value: {
          id: value?.id,
          pessoaId: value?.pessoa?.id || value?.pessoaId,
          nome: value?.nome || value?.pessoa?.nome,
          emailPrincipal: value?.emailPrincipal,
          tipoPessoa: value?.tipoPessoa,
        },
      },
    };

    onChange(event);
  };

  return (
    <SelectCreatableInput
      mutiple={mutiple}
      required={required}
      onBlur={onBlur}
      touched={touched}
      error={error}
      label={label}
      id={id}
      value={{ ...value }}
      autoFocus={autoFocus}
      disabled={disabled}
      onChange={handleChange}
      getOptionKey={(option) => {
        if (option) {
          return option?.id;
        }
        return '';
      }}
      getOptionLabel={(option) => {
        if (option) {
          return option?.nome || option?.pessoa?.nome;
        }
        return '';
      }}
      onClearInput={() => {
        onChange({ target: { id, value: undefined } });
      }}
      fetchData={carregarCliente}
      createData={async (data) => {
        const response = await clienteApi.post({ pessoa: { nome: data, tipoPessoa: 'FISICA' } });

        handleChange(response.data);
      }}
      fetchOnFocus
      tamanhoMinimo={tamanhoMinimo}
      maxLength={maxLength}
    />
  );
};

export default SelectClienteCreatable;
